import { Button, Stack } from "@mui/material";
import { useContext } from "react";
import { FileRejection, useDropzone } from "react-dropzone";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";

type Props = {
	onDrop: (acceptedFiles: any[], fileRejections: FileRejection[]) => void;
};
export default function DropzoneBtn({ onDrop }: Props) {
	const { values } = useContext(Context);
	const { translate } = useLocales();

	const { getRootProps } = useDropzone({
		multiple: false,
		accept: { "image/png": [] },
		maxSize: 1000000,
		disabled: false,
		onDrop
	});

	return (
		<Stack flexDirection={"row"} alignItems={"center"} gap={1}>
			<Button
				variant={values.file ? "outlined" : "contained"}
				size='small'
				{...getRootProps({ className: "dropzone" })}
			>
				{values.file ? translate("logo_selector.replace") : translate("logo_selector.add")}
			</Button>
		</Stack>
	);
}
